import { VendorSitesColorMapInfo } from "@/mocks/data/vendorSitesService/vendorSitesColorMap";

const vendorSitesInformation = {
  getVendorSiteColorMap: async (): Promise<Record<string, string>> => {
    const resp = VendorSitesColorMapInfo;
    return resp ?? null;
  },
};

export default vendorSitesInformation;